import { render, staticRenderFns } from "./ExpiredBasketItem.vue?vue&type=template&id=5b7e52d7&"
import script from "./ExpiredBasketItem.vue?vue&type=script&lang=js&"
export * from "./ExpiredBasketItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports